import { render, staticRenderFns } from "./VehicleStatus.vue?vue&type=template&id=909e7a22&lang=pug&"
import script from "./VehicleStatus.vue?vue&type=script&lang=ts&"
export * from "./VehicleStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports